var html5QrcodeScanner;
var html5QrCode;
var guardScreenQrCheckinCheckoutMode = 0
function selectGuardScreenQrCheckinCheckoutMode(mode) {
    guardScreenQrCheckinCheckoutMode = mode;
    return 1;
}

function openScannerModal() {

    $('#scannerModal').modal();

    setTimeout(function () {
        SetFocusElement('manualQrScanInput');
    }, 1000);
}

function closeScannerModal() {
    $('#scannerModal').modal('hide');
}

function createQrScanner(arg) {

    try {
        console.log("Setting up QR Scanner..");
        html5QrCode = new Html5Qrcode("reader");
        console.log("Done setting up QR Scanner");
    }
    catch (e) {
        console.log("Error while setting up QR Scanner");
        console.log(e);
    }

    return 1;
}

//function startScanGrab(arg) {
//    console.log("Starting Scan Grab");

//    html5QrCode.start(
//        {
//            facingMode: "environment"
//        },
//        {
//            fps: 20,    // Optional, frame per seconds for qr code scanning
//            qrbox: 250  // Optional, if you want bounded box UI
//        },
//        (decodedText, decodedResult) => {
//            console.log("decoded text: " + decodedText);

//            try {
//                stopScanGrab();
//                closeScannerModal();
//            }
//            catch (e) {
//                console.log(e);
//            }

//            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnScannedAutoAdmitPassFromGuardScreen', decodedText, guardScreenQrCheckinCheckoutMode);

//        },
//        (errorMessage) => {

//        })
//        .catch((err) => {
//            console.log("Scan error: " + err);
//        });

//    return 1;
//}

async function startScanGrab(arg) {
    console.log("Starting Scan Grab");

    const onSuccess = async (decodedText, decodedResult) => {
        console.log("Decoded text:", decodedText);
        try {
            stopScanGrab();
            closeScannerModal();
        } catch (e) {
            console.log("Error closing scanner:", e);
        }
        DotNet.invokeMethodAsync(
            'VisitForm.Client.UI.Guard',
            'OnScannedAutoAdmitPassFromGuardScreen',
            decodedText,
            guardScreenQrCheckinCheckoutMode
        );
    };

    const onError = (errorMessage) => {
       // console.log("Frame scan error:", errorMessage);
    };

    const config = { fps: 20, qrbox: 250 };

    try {
        const devices = await Html5Qrcode.getCameras();
        console.log("Cameras found:", devices);

        if (!devices || devices.length === 0) {
            throw new Error("No camera devices found.");
        }

        let preferredId = localStorage.getItem("qr-preferred-camera-id");
        console.log("Preferred camera from storage:", preferredId);
        let camera = devices.find(d => d.id === preferredId);

        if (!camera) {
            console.log("Looking for back/rear camera by label...");
            const keywords = ["back", "rear", "world", "environment"];
            camera = devices.find(d => {
                const lbl = (d.label || "").toLowerCase();
                return keywords.some(k => lbl.includes(k));
            });
        }

        if (!camera) {
            console.log("No matching label or preferred device. Starting with facingMode: environment...");
            await html5QrCode.start({ facingMode: "environment" }, config, onSuccess, onError);
            console.log("FacingMode environment started.");
            return 1;
        }

        console.log("Selected camera by deviceId:", camera);

        const tryStartWith = async (deviceId) => {
            console.log("Trying to start camera:", deviceId);
            await html5QrCode.start({ deviceId: { exact: deviceId } }, config, onSuccess, onError);
            console.log("Camera started successfully:", deviceId);
            localStorage.setItem("qr-preferred-camera-id", deviceId);
        };


        try {
            await tryStartWith(camera.id);
        } catch (firstErr) {
            console.warn("Primary camera failed:", firstErr);
            const others = devices.filter(d => d.id !== camera.id);
            let started = false;
            for (const dev of others) {
                try {
                    await tryStartWith(dev.id);
                    started = true;
                    break;
                } catch (e) {
                    console.warn("Camera failed:", dev.id, e);
                }
            }
            if (!started) throw firstErr;
        }

        console.log("QR scanner running.");
        return 1;
    } catch (err) {
        console.error("Fatal scan error:", err);

        try {
            console.log("Fallback: trying facingMode: environment after error...");
            await html5QrCode.start({ facingMode: "environment" }, config, onSuccess, onError);
            console.log("Fallback facingMode started.");
            return 1;
        } catch (e2) {
            console.error("Fallback facingMode also failed:", e2);
            return 0;
        }
    }
}



function stopScanGrab(arg) {
    try {
        html5QrCode.stop().then((ignore) => {
            console.log("Stopped Scan Grab");
        }).catch((err) => {
            console.log("Error Stop Scan Grab: " + err);
        });
    }
    catch (e) {
        console.log(e);
    }


    return 1;
}


function openAttachPhotoModal(arg) {
    $('#attachPhotoModal').modal();
}

function captureCameraImage(arg) {
    $("#captureCameraInput").click();
}

function readCameraImage(arg) {
    $("#readFileCameraInput").click();
}

function openSerialScannerSettingsModal(arg) {
    $('#serialScannerSettingsModal').modal();
}

function uploadCheckinImage(baseUrl, arg, checkinId, gridIndex, inputid, screenid, blobidentifier) {

    const path = 'api/Image/checkinimageupload/';

    const url = new URL(
        path +
        encodeURIComponent(screenid) + "/" +
        encodeURIComponent(checkinId) + "/" +
        encodeURIComponent(gridIndex) + "/" +
        encodeURIComponent(blobidentifier),
        baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
    ).toString();

    var file_data = $('#' + inputid).prop('files')[0];
    var form_data = new FormData();
    form_data.append('file', file_data);

    $.ajax({
        url: url,
        dataType: 'text',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", 'Bearer ' + arg);
        },
        success: function () { },
        error: function () { }
    });
}


function showAttachedImage(inputid) {
    var file_data = $('#' + inputid).prop('files')[0];

    $('#displayDownloadedPhoto').hide();
    $('#displayAttachedPhoto').show();


    const FR = new FileReader();

    FR.addEventListener("load", function (evt) {

        console.log("file read!");
        console.log(evt.target.result);

        document.querySelector("#displayAttachedPhoto").src = evt.target.result;
        //document.querySelector("#b64").textContent = evt.target.result;
    });

    FR.readAsDataURL(file_data);

}
function clearCameraInputs() {
    clearInputFile(document.getElementById('captureCameraInput'));
    clearInputFile(document.getElementById('readFileCameraInput'));
}


$(document).ready(function () {
    $(document).on('hide.bs.modal', '#scannerModal', function () {
        stopScanGrab();
    });
    $(document).on('hidden.bs.modal', '#scannerModal', function () {
        stopScanGrab();
    });
});

function forceClearQrUserManualField() {
    const input = document.getElementById('manualQrScanInput');
    if (input) {
        input.value = '';
        input.dispatchEvent(new Event('input')); // ensures @bind-Value updates in Blazor

    }
}

// Camera preference helpers for Blazor QR scanner

const VISITFORM_QRSCANNER_STORAGE_KEY = "qr-preferred-camera-id";

async function listCameras() {
    try {
        if (typeof Html5Qrcode === "undefined" || !Html5Qrcode.getCameras) {
            console.warn("Html5Qrcode not available. Returning empty camera list.");
            return [];
        }
        const devices = await Html5Qrcode.getCameras(); // [{ id, label }]
        return (devices || []).map(d => ({ id: d.id, label: d.label || "" }));
    } catch (e) {
        console.error("Error listing cameras:", e);
        return [];
    }
}

function getPreferredId() {
    try {
        return localStorage.getItem(VISITFORM_QRSCANNER_STORAGE_KEY);
    } catch {
        return null;
    }
}

function setPreferredId(deviceId) {
    try {
        localStorage.setItem(VISITFORM_QRSCANNER_STORAGE_KEY, deviceId);
        console.log("Preferred camera saved:", deviceId);
    } catch (e) {
        console.error("Failed to save preferred camera id:", e);
    }
}

function clearPreferredId() {
    try {
        localStorage.removeItem(VISITFORM_QRSCANNER_STORAGE_KEY);
        console.log("Preferred camera cleared.");
    } catch (e) {
        console.error("Failed to clear preferred camera id:", e);
    }
}

